<template>
      <b-card>
        <b-form @submit.prevent="userAdd">
          <b-row>
            <b-col sm="12" md="6">
                <b-form-group label="*First Name:" label-for="usrfirstname">
                    <b-form-input maxlength="200" :class="{ 'is-invalid' : $v.form.usrfirstname.$error }" id="usrFirstNameField" v-model="form.usrfirstname" type="text" class="form-control" placeholder="Enter First Name"  aria-describedby="usrFirstNameField" />
                    <b-form-invalid-feedback id="usrFirstNameField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group label="*Last Name:" label-for="usrlastname">
                    <b-form-input maxlength="40" :class="{ 'is-invalid' : $v.form.usrlastname.$error }" id="usrLastNameField" v-model="form.usrlastname" type="text" class="form-control" placeholder="Enter Last Name"   aria-describedby="usrLastNameField" />
                    <b-form-invalid-feedback id="usrLastNameField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form-group label="*Email Address:" label-for="usremail">
                    <b-form-input maxlength="100" :class="{ 'is-invalid' : $v.form.usremail.$error }" id="usrEmailField" v-model="form.usremail" type="text" class="form-control" placeholder="Enter Email Address"  aria-describedby="usrEmailField" />
                    <b-form-invalid-feedback id="usrEmailField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
            <b-col>
              <b-form-group label="User Status">
                <b-form-radio-group v-model="form.usractive" :options="statusItems" name="radioOpenions">
                </b-form-radio-group>
              </b-form-group>
            </b-col>  
          </b-row>

          <b-row v-if="showUserRoles_ORG">
            <b-col sm="12" md="6">
              <b-form-group label="*Select Organization:" label-for="usrOrgIndexField" id="usrOrgIndexFieldAA">
              <b-form-select :class="{ 'is-invalid' : $v.form.usrorgindex.$error }" v-model="form.usrorgindex" :options="orgItems" id="usrOrgIndexField"  aria-describedby="usrOrgIndexField"  />
              <b-form-invalid-feedback id="usrOrgIndexField">
                   This is a required field
                </b-form-invalid-feedback>
              </b-form-group> 
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group label="*Select User Role:" label-for="usrRoleIndexField">
                  <b-form-select  :class="{ 'is-invalid' : $v.form.usrroleindex.$error }" v-model="form.usrroleindex" :options="roleItems"  id="usrRoleIndexField"  aria-describedby="usrRoleIndexField" />    
                  <b-form-invalid-feedback id="usrRoleIndexField">
                       This is a required field
                    </b-form-invalid-feedback>
              </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-button type="button" v-b-tooltip.hover title="Cancel" variant="secondary" @click.stop="gotolist()"  class="px-4">Cancel</b-button>
              <b-button type="submit" v-b-tooltip.hover title="Save" variant="primary"  class="px-4 pull-right">Save</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'  
import { validationMixin } from 'vuelidate';  
import { required, maxLength } from 'vuelidate/lib/validators';
import { getResponseMessages, getUserInfo } from '../../_helpers';
export default {
  name: 'User_Add',
  data() {
    return {
      roleItems: [{
        text: 'Please select a role',
        value: '',
      }],
      orgItems :[{
        text: 'Please select a organization',
        value: '',
      }],
      statusItems: [
        { text: 'Active', value: 0 },
        { text: 'Inactive', value: 1 }
      ],
      form: {
        usrfirstname:'',
        usrlastname:'',
        usremail:'',
        usrorgindex:'',
        usrroleindex:'',
        usractive:0
      },
      showUserRoles_ORG:false
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    form: {
      usrfirstname: {
        required,
        maxLength: maxLength(40)
      },
      usrlastname: {
        required,
        maxLength: maxLength(40)
      },
      usremail: {
        required,
        maxLength: maxLength(100)
      },
      usrorgindex: {
        required
      },
      usrroleindex: {
        required
      }
    }  
  },
  created(){
    this.loadUserData();
    const user = getUserInfo();
    if(user.orgIndex != ''){
      this.form.usrorgindex = user.orgIndex;
    }
    if(user.roleid == 1 || user.role == 'Admin'){
      this.showUserRoles_ORG = true;
    }
    if(this.$route.params.id != undefined){
      this.getUserById(this.$route.params.id)
    }
  },  
  methods: {
     ...mapActions('org', ['getById','saveData']),
    userAdd() {
      this.$v.form.$touch();
      if(this.$v.form.$error) return
      this.$store.dispatch('saveData',{url:'user/saveUser',data: this.form}).then((res) => { 
        this.$toastr('success', getResponseMessages(res.data.messages), 'Success')
        this.$router.push('/user')
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    gotolist () {
        this.$router.push('/user/list')
    },
    getUserById(id) {
      this.$store.dispatch('getById', {url:'user/getUserById',data : { 'usrIndex':id }}).then((res) => {
        this.form = Object.assign({}, res)  
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
        this.gotolist()
      });
    },
    loadUserData() {
      this.$store.dispatch('getById', {url:'user/loadUserData',data :{}}).then((res) => {
        res.org.forEach((version) => {
          this.orgItems.push(version);
        });
        res.role.forEach((version) => {
          this.roleItems.push(version);
        });
        this.roleItems.forEach((el, index) => {
          if (el.text === 'User' || el.text ==='user'){
            this.form.usrroleindex =  el.value;
          }
        });
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
  }
}
</script>
